var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import React from "react";
const SvgInfoCircleSolid = props => /*#__PURE__*/React.createElement("svg", _extends({
  "data-name": "Layer 1",
  viewBox: "0 0 1080 1080"
}, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
  d: "M540 0C241.77 0 0 241.77 0 540s241.77 540 540 540 540-241.77 540-540S838.23 0 540 0zm-4.5 209a72.16 72.16 0 11-72.16 72.16A72.17 72.17 0 01535.5 209zm157.95 662h-306.9v-76.68h77.11V486.9h-77.11v-57.44h229.79v364.86h77.11z"
})));
export default SvgInfoCircleSolid;